export function updateSelectedWorkspace(workspace) {
  if (workspace) {
    return {
      type: "UPDATE_SELECTED_WORKSPACE",
      payload: workspace,
    };
  }
}

export function updateSelectedStore(store) {
  if (store) {
    return {
      type: "UPDATE_SELECTED_STORE",
      payload: store,
    };
  }
}

export function updateStoresList(newList) {
  return {
    type: "FETCH_STORES_SUCCESS",
    payload: { data: newList },
  };
}

export function handleOnLogin(data) {
  return {
    type: "ON_LOGIN",
    payload: data,
  };
}
